import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Block } from 'slate';
import { Editor } from 'slate-react';
import classNames from 'classnames';
import GutterBlockTypes from '../../../types/GutterBlockTypes';
import { IS_SAFARI } from '../../../helpers/BrowserHelpers';
import makeGutterBlock from '../../GutterBlockPlugin/makeGutterBlock';
import groupCellsByRow from '../utils/groupCellsByRow';
import TableRow from './TableRow';
import TableStyle from './TableStyle';
import TableWrapper from './TableWrapper';
import TableColumnControl from './TableColumnControl';
import TableColumnControls from './TableColumnControls';

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedTableId: null,
      tableSelection: null
    });

    _defineProperty(_assertThisInitialized(_this), "tableRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "onSelectedTableChange", function (selectedTableId) {
      _this.setState({
        selectedTableId: selectedTableId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectionChange", function (tableSelection) {
      _this.setState({
        tableSelection: tableSelection
      });
    });

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var store = this.props.store;
      var tableId = this.props.node.getIn(['nodes', 0, 'data', 'tableId']);
      store.subscribeToItem('lastFocusedTableId', this.onSelectedTableChange);
      store.subscribeToItem(tableId, this.onSelectionChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var store = this.props.store;
      var tableId = this.props.node.getIn(['nodes', 0, 'data', 'tableId']);
      store.unsubscribeFromItem('lastFocusedTableId', this.onSelectedTableChange);
      store.unsubscribeFromItem(tableId, this.onSelectionChange);
    }
  }, {
    key: "renderColumnsControl",
    value: function renderColumnsControl(tableId, columnCount, focusedColumnIndex) {
      var _this2 = this;

      return React.createElement("tr", {
        className: "slite-editor-table-control-header transition",
        contentEditable: false
      }, React.createElement("th", {
        className: "zindex-huge"
      }, React.createElement("div", {
        className: "slite-editor-table-helper"
      }), React.createElement("div", {
        className: "slite-editor-table-helper"
      })), _toConsumableArray(Array(columnCount)).map(function (_, i) {
        return React.createElement(TableColumnControl, {
          key: i,
          editor: _this2.props.editor,
          store: _this2.props.store,
          tableId: tableId,
          columnIndex: i,
          isFirstColumn: i === 0,
          isLastColumn: i >= columnCount - 1,
          isMobile: _this2.props.isMobile,
          isFocused: focusedColumnIndex === i
        });
      }));
    }
  }, {
    key: "renderRows",
    value: function renderRows(tableId, rows, focusedRowIndex) {
      var _this3 = this;

      var _ref = this.state.tableSelection || {},
          _ref$selectedCellsCoo = _ref.selectedCellsCoords,
          selectedCellsCoords = _ref$selectedCellsCoo === void 0 ? [] : _ref$selectedCellsCoo;

      var selectedRowIndexes = selectedCellsCoords.reduce(function (memo, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            rowIndex = _ref3[0];

        if (!memo.includes(rowIndex)) memo.push(rowIndex);
        return memo;
      }, []);
      var minSeletedRowIndex = Math.min.apply(Math, _toConsumableArray(selectedRowIndexes));
      var maxSeletedRowIndex = Math.max.apply(Math, _toConsumableArray(selectedRowIndexes));
      return rows.map(function (row, index) {
        return React.createElement(TableRow, {
          key: index,
          tableId: tableId,
          rowIndex: index,
          editor: _this3.props.editor,
          store: _this3.props.store,
          isSelected: selectedRowIndexes.includes(index),
          isFirstInSelection: minSeletedRowIndex === index,
          isLastInSelection: maxSeletedRowIndex === index,
          isLastRow: index + 1 === rows.length,
          isMobile: _this3.props.isMobile,
          isFocused: focusedRowIndex === index
        }, row);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          node = _this$props.node,
          editor = _this$props.editor,
          store = _this$props.store,
          attributes = _this$props.attributes;
      var tableId = node.getIn(['nodes', 0, 'data', 'tableId']);
      var rows = groupCellsByRow(this.props.children);
      var selectedTableId = editor.getCurrentTableId();
      var selectionInTable = selectedTableId === tableId;

      var _ref4 = selectionInTable ? editor.getCellCoords(editor.value.startBlock) : [null, null],
          _ref5 = _slicedToArray(_ref4, 2),
          focusedRowIndex = _ref5[0],
          focusedColumnIndex = _ref5[1];

      return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({
        className: "slite-editor-table-container"
      }, attributes), React.createElement(TableStyle, {
        tableId: tableId,
        table: node,
        store: store,
        readOnly: editor.readOnly
      }), React.createElement(TableWrapper, {
        key: tableId,
        table: node
      }, React.createElement("table", {
        ref: this.tableRef,
        className: classNames('slite-editor-table', {
          'is-selected': this.state.selectedTableId === tableId,
          'read-only': editor.readOnly,
          'is-safari': IS_SAFARI,
          'selection-in': selectionInTable
        }),
        "data-slite-editor-table": tableId
      }, React.createElement(TableColumnControls, {
        editor: editor,
        store: this.props.store,
        tableId: tableId,
        table: this.props.node,
        focusedColumnIndex: focusedColumnIndex,
        isMobile: this.props.isMobile
      }), React.createElement("tbody", {
        className: "slite-editor-table-body"
      }, this.renderRows(tableId, rows, focusedRowIndex))))));
    }
  }]);

  return Table;
}(Component);

_defineProperty(Table, "propTypes", {
  node: PropTypes.instanceOf(Block),
  editor: PropTypes.instanceOf(Editor),
  store: PropTypes.shape({
    subscribeToItem: PropTypes.func,
    unsubscribeFromItem: PropTypes.func
  }),
  attributes: PropTypes.object,
  children: PropTypes.node,
  isMobile: PropTypes.bool
});

export default makeGutterBlock({
  gutterBlockType: GutterBlockTypes.ALL_BLOCKS
})(Table);